import {Component} from '@angular/core';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    standalone: true,
    styleUrls: ['./about.component.scss']
})
export class AboutComponent {
}